
const Slash = () => {
  return (
<svg width="10" height="22" viewBox="0 0 10 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.80108 1.09789L1.19895 20.9021" stroke="#E0E0E0" strokeWidth="2" />
</svg>
  )
}

export default Slash